var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2Step(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#24333A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4289 40.664C27.1382 38.488 29.2609 36.7067 30.7969 35.32C32.3329 33.912 33.6235 32.4507 34.6689 30.936C35.7355 29.4 36.2689 27.896 36.2689 26.424C36.2689 25.0373 35.9275 23.9493 35.2449 23.16C34.5835 22.3493 33.5062 21.944 32.0129 21.944C30.5622 21.944 29.4315 22.4027 28.6209 23.32C27.8315 24.216 27.4049 25.4213 27.3409 26.936H24.5249C24.6102 24.5467 25.3355 22.7013 26.7009 21.4C28.0662 20.0987 29.8262 19.448 31.9809 19.448C34.1782 19.448 35.9169 20.056 37.1969 21.272C38.4982 22.488 39.1489 24.1627 39.1489 26.296C39.1489 28.0667 38.6155 29.7947 37.5489 31.48C36.5035 33.144 35.3089 34.616 33.9649 35.896C32.6209 37.1547 30.9035 38.6267 28.8129 40.312H39.8209V42.744H24.4289V40.664Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Step);
export default __webpack_public_path__ + "static/media/2step.90e1e9b2f96e66b77a996a7d29daae8a.svg";
export { ForwardRef as ReactComponent };